// extracted by mini-css-extract-plugin
module.exports = {"gift-icon":"styles_gift-icon__38qlg","giftIcon":"styles_gift-icon__38qlg","primary":"styles_primary__1G4a7","secondary":"styles_secondary__BYX-e"};